import { render, staticRenderFns } from "./CreateCommentDialog.vue?vue&type=template&id=73a93c62"
import script from "./CreateCommentDialog.vue?vue&type=script&lang=js"
export * from "./CreateCommentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports